import React, { useState } from "react";
import PropTypes from "prop-types";
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from "reactstrap";
import ManageColumnsModalFields from "components/Common/ManageColumnsModalFields";
import {
    copyReportTableToClipboard,
    exportReportTableToCsv,
    exportReportTableToExcel,
    exportReportTableToPdf,
    getVisibleReportTableColumns,
} from "helpers/reportTableExportHelpers";

const ReportTableToolbar = ({
    pageName = "Report",
    tableKey = "report-table",
    columns = [],
    visibleColumnOrder = [],
    columnOrder = [],
    orderedColumns = [],
    visibleColumns = {},
    onColumnToggle,
    getExportRows,
    showCopy = false,
    showCsv = false,
}) => {
    const [showColumnModal, setShowColumnModal] = useState(false);
    const toggleColumnModal = () => setShowColumnModal((previous) => !previous);

    const visibleReportColumns = getVisibleReportTableColumns(columns, visibleColumnOrder);

    const getRows = () =>
        typeof getExportRows === "function" ? getExportRows(visibleReportColumns) : [];

    const handleCopy = async () => {
        await copyReportTableToClipboard({
            visibleColumns: visibleReportColumns,
            rows: getRows(),
        });
    };

    const handleCsv = () => {
        exportReportTableToCsv({
            pageName,
            visibleColumns: visibleReportColumns,
            rows: getRows(),
        });
    };

    const handleExcel = () => {
        exportReportTableToExcel({
            pageName,
            visibleColumns: visibleReportColumns,
            rows: getRows(),
        });
    };

    const handlePdf = () => {
        exportReportTableToPdf({
            pageName,
            visibleColumns: visibleReportColumns,
            rows: getRows(),
        });
    };

    return (
        <>
            <div
                className="d-flex align-items-center justify-content-between px-2 py-2 pad-btm"
                style={{ backgroundColor: "#f8fafc" }}
            >
                <div className="d-flex align-items-center gap-2">
                    <Button
                        color="link"
                        className="text-dark d-flex align-items-center gap-1 p-0 fw-semibold no-underline table-action-icon"
                        type="button"
                        onClick={toggleColumnModal}
                    >
                        <i className="fa fa-columns" aria-hidden="true" />
                        COLUMNS
                    </Button>
                    {showCopy ? (
                        <Button
                            color="link"
                            className="text-dark d-flex align-items-center gap-1 p-0 fw-semibold no-underline icon-csv"
                            type="button"
                            onClick={handleCopy}
                        >
                            <i className="fa fa-copy" aria-hidden="true" />
                            COPY
                        </Button>
                    ) : null}
                    {showCsv ? (
                        <Button
                            color="link"
                            className="text-dark d-flex align-items-center gap-1 p-0 fw-semibold no-underline icon-csv"
                            type="button"
                            onClick={handleCsv}
                        >
                            <i className="fas fa-file-csv" aria-hidden="true" />
                            CSV
                        </Button>
                    ) : null}
                    <Button
                        color="link"
                        className="text-dark d-flex align-items-center gap-1 p-0 fw-semibold no-underline icon-excel"
                        type="button"
                        onClick={handleExcel}
                    >
                        <i className="fas fa-file-excel" aria-hidden="true" />
                        EXCEL
                    </Button>
                    <Button
                        color="link"
                        className="text-dark d-flex align-items-center gap-1 p-0 fw-semibold no-underline icon-pdf"
                        type="button"
                        onClick={handlePdf}
                    >
                        <i className="fa fa-file-pdf" aria-hidden="true" />
                        PDF
                    </Button>
                </div>
            </div>

            <Modal
                size="md"
                isOpen={showColumnModal}
                toggle={toggleColumnModal}
                backdrop="static"
                centered
                className="modal-full-height"
            >
                <ModalHeader toggle={toggleColumnModal}>Manage Columns</ModalHeader>
                <ModalBody className="p-4 modal-height-fixed">
                    <ManageColumnsModalFields
                        columns={columns}
                        columnOrder={columnOrder}
                        orderedColumns={orderedColumns}
                        visibleColumns={visibleColumns}
                        onToggle={onColumnToggle}
                        tableKey={tableKey}
                        showColumnModal={showColumnModal}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" type="button" onClick={toggleColumnModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

ReportTableToolbar.propTypes = {
    pageName: PropTypes.string,
    tableKey: PropTypes.string,
    columns: PropTypes.array,
    visibleColumnOrder: PropTypes.array,
    columnOrder: PropTypes.array,
    orderedColumns: PropTypes.array,
    visibleColumns: PropTypes.object,
    onColumnToggle: PropTypes.func,
    getExportRows: PropTypes.func,
    showCopy: PropTypes.bool,
    showCsv: PropTypes.bool,
};

export default ReportTableToolbar;
